import { useRequest, useView } from '@10000/react'
import { Box } from '../widgets'
import { InputScreen, useShell } from '../layout'
import { SelectableList } from '../forms'

export const SelectSquiz = ({ active }) => {
  const request = useRequest('tenant')
  const { currentSquizzes } = useView('tenant')

  useShell({ active, mode: 'navigate' })

  const squizSelected = ({ squiz }) => request('leaderChanged', { id: currentSquizzes[squiz].id })

  return (
    <InputScreen
      centered
      onSubmit={squizSelected}
      footerButton="Select"
      title="Select Team"
      minHeight={0}
    >
      <Box overflow="auto" py={8}>
        <SelectableList
          name="squiz"
          list={currentSquizzes.map(x => x.teamName)}
        />
      </Box>
    </InputScreen>
  )
}